// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__VI3uf","logo_div":"Navbar_logo_div__ULgrn","logo":"Navbar_logo__WjNMT","links":"Navbar_links__aQqlv","nav_links":"Navbar_nav_links__r28lk"};